export const SITE_ORIGIN = 'https://www.disgenet.com';
export const SITE_NAME = 'DISGENET';
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/static/images/KeyVisuals/1920x800DISGENET.jpg`;

export const DEFAULT_META_DESCRIPTION =
  'Curated gene-disease and variant-disease associations for target identification, biomarker discovery and precision medicine. REST API, R package and Cytoscape app.';

export function toCanonicalUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (normalized === '/') return `${SITE_ORIGIN}/`;
  return `${SITE_ORIGIN}${normalized}`;
}

export function getHomeJsonLd() {
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: SITE_NAME,
      legalName: 'MedBioinformatics Solutions SL',
      url: `${SITE_ORIGIN}/`,
      logo: `${SITE_ORIGIN}/static/images/LOGO_DISGENET.svg`,
      sameAs: ['https://blog.disgenet.com', 'https://casestudies.disgenet.com'],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: SITE_NAME,
      applicationCategory: 'HealthApplication',
      applicationSubCategory: 'Bioinformatics',
      operatingSystem: 'Web',
      url: `${SITE_ORIGIN}/`,
      description: DEFAULT_META_DESCRIPTION,
      publisher: {
        '@type': 'Organization',
        name: 'MedBioinformatics Solutions SL',
        url: `${SITE_ORIGIN}/`,
      },
      offers: {
        '@type': 'Offer',
        url: `${SITE_ORIGIN}/plans`,
      },
    },
  ];
}
